import MailchimpSubscribe from "react-mailchimp-subscribe";
import { Newsletter } from "./Newsletter";
export const MailchimpForm = () => {
  const postUrl = `http://eepurl.com/jvmpus?u=$id={}`

  return (
    <>
        <MailchimpSubscribe url={postUrl} render={({subscribe,status,message}) => (
            <Newsletter
                status={status}
                message={message}
                onValidate={formData => subscribe(formData)}
            />
        )}/>
    </>
  )
};
